function arrayLength(value) {
  return Array.isArray(value) ? value.length : 0
}

function repairShape(dataJson) {
  const data = dataJson && typeof dataJson === 'object' ? dataJson : {}
  const forms = Array.isArray(data.forms) ? data.forms : []
  const actions = Array.isArray(data.actions) ? data.actions : []
  return {
    forms: forms.length,
    fields: forms.reduce((total, form) => total + arrayLength(form?.remarks), 0),
    datasourceOptions: forms.reduce(
      (total, form) => total + (Array.isArray(form?.remarks)
        ? form.remarks.reduce((fieldTotal, field) => fieldTotal + arrayLength(field?.datasource), 0)
        : 0),
      0,
    ),
    onLoad: arrayLength(data.onLoad),
    postCommands: arrayLength(data.postCommands),
    actions: actions.length,
    actionCommands: actions.reduce((total, action) => total + arrayLength(action?.commands), 0),
    alerts: arrayLength(data.alerts),
  }
}

const PRESERVED_PARTS = [
  ['forms', 'formularios'],
  ['fields', 'campos'],
  ['datasourceOptions', 'opciones de catálogo'],
  ['onLoad', 'operaciones onLoad'],
  ['postCommands', 'comandos posteriores'],
  ['actions', 'acciones'],
  ['actionCommands', 'comandos de acciones'],
  ['alerts', 'alertas'],
]

/* Una reparación de lint puede corregir referencias y propiedades, pero no debe
   “resolver” los errores eliminando comportamiento del resultado original. */
export function validateRepairPreservation(before, after) {
  const original = repairShape(before)
  const repaired = repairShape(after)
  return PRESERVED_PARTS.reduce((diagnostics, [key, label]) => {
    if (repaired[key] < original[key]) {
      diagnostics.push({
        code: 'REPAIR_FUNCTIONAL_LOSS',
        severity: 'error',
        message: 'La reparación redujo ' + label + ' de ' + original[key] + ' a ' + repaired[key] + '.',
        detail: { part: key, before: original[key], after: repaired[key] },
      })
    }
    return diagnostics
  }, [])
}
